export default "__VITE_ASSET__CgJ1WmE4__"